import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../utils/api';
import AccessSettings from '../../components/AccessSettings';
import { usePortalAccess } from '../../components/PortalAccess';

const STATUS_LABELS = { pending: 'Ожидает', approved: 'Одобрен', rejected: 'Отклонён' };

export default function Users() {
  const navigate = useNavigate();
  const { is_owner: isOwner } = usePortalAccess();
  const [accessDirty, setAccessDirty] = useState(false);
  const [accessUser, setAccessUser] = useState(null);
  const [tab, setTab] = useState('pending');
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const load = async (status) => {
    setLoading(true);
    setError('');
    try {
      const res = await api.get('/api/admin/users', { params: { status } });
      setUsers(res.data);
    } catch {
      setError('Ошибка загрузки');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { if (tab !== 'access') load(tab); }, [tab]);

  const changeAccessView = action => {
    if (accessDirty && !window.confirm('Продолжить без сохранения настроек доступа?')) return;
    setAccessDirty(false); action();
  };

  const reject = async (userId) => {
    if (!window.confirm('Отклонить пользователя?')) return;
    try {
      await api.post(`/api/admin/users/${userId}/reject`);
      setUsers(prev => prev.filter(u => u.id !== userId));
    } catch {
      setError('Ошибка отклонения');
    }
  };

  const deleteUser = async (userId, name) => {
    if (!window.confirm(`Удалить пользователя «${name}»? Все его заявки тоже будут удалены.`)) return;
    try {
      await api.delete(`/api/admin/users/${userId}`);
      setUsers(prev => prev.filter(u => u.id !== userId));
    } catch {
      setError('Ошибка удаления');
    }
  };

  return (
    <div className="page">
      <div className="page-header"><h1>Пользователи</h1></div>

      <div className="tabs">
        {[['pending', 'Ожидают'], ['approved', 'Одобрены'], ['rejected', 'Отклонены'], ...(isOwner ? [['access', 'Роли и доступ']] : [])].map(([val, label]) => (
          <button key={val} className={`tab ${tab === val ? 'tab--active' : ''}`} onClick={() => changeAccessView(() => { setAccessUser(null); setTab(val); })}>{label}</button>
        ))}
      </div>

      {tab === 'access' && <AccessSettings onDirtyChange={setAccessDirty} />}
      {accessUser && isOwner && <AccessSettings key={accessUser} userId={accessUser} onDirtyChange={setAccessDirty} onClose={() => setAccessUser(null)} />}
      {tab !== 'access' && <>
      {error && <div className="error-msg">{error}</div>}

      {loading ? (
        <div className="page-loader">Загрузка...</div>
      ) : users.length === 0 ? (
        <div className="empty-state">Нет пользователей</div>
      ) : (
        <div className="table-wrap">
          <table className="data-table">
            <thead>
              <tr>
                <th>Имя</th>
                <th>Telegram</th>
                <th>Города</th>
                <th>Описание</th>
                <th>Роль</th>
                <th>Статус</th>
                <th>Дата</th>
                <th>Действия</th>
              </tr>
            </thead>
            <tbody>
              {users.map(u => (
                <tr key={u.id}>
                  <td>{u.full_name}</td>
                  <td>{u.telegram_username ? `@${u.telegram_username}` : `ID: ${u.telegram_id}`}</td>
                  <td>{(u.cities_requested || []).join(', ') || '—'}</td>
                  <td className="description-cell">{u.self_description || '—'}</td>
                  <td>{u.role_name || '—'}</td>
                  <td><span className={`status-badge status--${u.status}`}>{STATUS_LABELS[u.status]}</span></td>
                  <td>{new Date(u.created_at).toLocaleDateString('ru-RU')}</td>
                  <td>
                    <div className="action-btns">
                      {isOwner && u.status === 'pending' && (
                        <>
                          <button className="btn-success small" onClick={() => navigate(`/admin/users/${u.id}/approve`)}>Одобрить</button>
                          <button className="btn-danger small" onClick={() => reject(u.id)}>Отклонить</button>
                        </>
                      )}
                      {isOwner && u.status !== 'pending' && (
                        <button className="btn-secondary small" onClick={() => navigate(`/admin/users/${u.id}/edit`)}>Изменить</button>
                      )}
                      {isOwner && <><button className="btn-secondary small" onClick={() => changeAccessView(() => setAccessUser(u.id))}>Доступ</button><button className="btn-danger small" onClick={() => deleteUser(u.id, u.full_name)}>Удалить</button></>}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      </>}
    </div>
  );
}
